import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
// actions & helper
import { required } from '../../../../utils/validation';
import { getHTOAppointmentCancelReasons, cancelHTOOrder } from '../../../../actionCreators/hto';
import { setToastMessage } from '../../../../actionCreators/common';
// import getSetCookie from '../../../../cookie';

function HTOCancelAppointment(props) {

    const [cancelError, setCancelError] = useState();
    useEffect(() => {
        props.getHTOAppointmentCancelReasons();
    }, []);

    const prevCancelledOrder = useRef(null);
    useEffect(() => {
        if (prevCancelledOrder !== props.cancelledOrder) {
            if (props.cancelledOrder) {
                if (props.cancelledOrder.isError) {
                    '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
                    setCancelError(props.cancelledOrder.error);
                    '#endif'; // eslint-disable-line
                    '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
                    props.setToastMessage({ message: props.cancelledOrder.error });
                    '#endif'; // eslint-disable-line
                } else {
                    props.navTo('cancel-appointment-success');
                    '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
                    setCancelError('');
                    '#endif'; // eslint-disable-line
                }
            } else {
                '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
                setCancelError('');
                '#endif'; // eslint-disable-line
            }
        }
    }, [props.cancelledOrder]);

    const submit = data => {
        if (data.reason) {
            // const orderId = getSetCookie.getCookie('orderId');
            const orderId = props.orderId;
            if (orderId) props.cancelHTOOrder(orderId, data.reason);
        }
    };

    return (
        <div className="hto-appointment-cancel pd-10">
            <h2 className="margin-b10 mr-b10 text-uppercase fw500 fs24 fsp16">{props.htoConfig.appointmentCancelReason.heading}</h2>
            <p className="margin-b25 mr-b25 fs14 fsp14">{props.htoConfig.appointmentCancelReason.description}</p>
            <Form
                onSubmit={submit}
            >
                {({ handleSubmit }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Field name="reason" validate={required}>
                                {({ input, meta }) => (
                                    <div className="mr-b20 margin-b25">
                                        <select {...input} className="form-control">
                                            <option value="">Select A Reason</option>
                                            {props.appointmentCancelReasons && props.appointmentCancelReasons.map((data, key) => <option value={data} key={key}>{data}</option>)}
                                        </select>
                                        <span className="block margin-t4 fs10 mr-t4 fsp10 text-color_brick_red">{meta.error && meta.touched ? meta.error : ''}</span>
                                    </div>
                                )}
                            </Field>
                            <div className="display-flex">
                                <button type="button" onClick={() => props.navTo('confirm-appointment')} className="flex-1 hto-btn hto-btn__default hto-cancel-btn margin-r5 mr-r5">Back</button>
                                <button type="submit" className="flex-1 hto-btn hto-btn__warn">Cancel Appointment</button>
                            </div>
                            {cancelError && <div className="margin-t20 text-color_brick_red">{cancelError}</div>}
                        </form>
                    );
                }}
            </Form>
        </div>
    );
}

const mapStateToProps = state => ({
    appointmentCancelReasons: state.hto.appointmentCancelReasons,
    htoConfig: state.hto.htoConfig,
    cancelledOrder: state.hto.cancelledOrder
});

const mapDispatchToProps = dispatch => ({
    getHTOAppointmentCancelReasons: () => dispatch(getHTOAppointmentCancelReasons()),
    cancelHTOOrder: (orderId, reason) => dispatch(cancelHTOOrder(orderId, reason)),
    setToastMessage: data => dispatch(setToastMessage(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(HTOCancelAppointment);
